import { logout } from '~/lib/logout';
import { useT } from '~/i18n';

interface Props {
  /** Para el riel de las consolas, que no es la barra del candidato. */
  className?: string;
}

/**
 * "Salir", en las tres superficies.
 *
 * Discreto a propósito: es tinta apagada, no un botón púrpura. El púrpura es la
 * acción que la pantalla QUIERE que pase, y cerrar sesión nunca lo es —pero
 * tiene que estar siempre a la vista, porque cuando alguien lo busca es porque
 * el teléfono no es suyo.
 *
 * Un `<button>` pelado y no el `Button` del sistema: esto no es una acción de
 * página, es cromo de la barra, y comparte forma con `.shell__link` para que la
 * barra se lea como una sola línea.
 */
export default function LogoutButton({ className = 'shell__exit' }: Props) {
  const t = useT('common');
  return (
    <button type="button" className={className} onClick={() => logout()}>
      {t.shell.logout}
    </button>
  );
}
